import { api } from '../instance';
export const trackEmailCollection = (trackEmailCollectionDto) => {
    return api.post('/analytics/track-email-collection', trackEmailCollectionDto);
};
//# sourceMappingURL=track-email-collection.api.js.map